import React from 'react';
import { IIconProps, sizeMap } from './types';

export const Bin = ({ className, size = 'medium' }: IIconProps) => {
  return (
    <svg
      className={className}
      width={sizeMap[size].width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1667 4.66669L19.3333 23H4.66668L2.83334 4.66669"
        stroke="currentcolor"
        strokeWidth={sizeMap[size].strokeWidth}
      />
      <path
        d="M6.5 4.66667V2.86083C6.5 2.61647 6.54813 2.37449 6.64165 2.14872C6.73516 1.92296 6.87223 1.71782 7.04503 1.54503C7.394 1.19605 7.86731 1 8.36083 1H15.6392C15.8835 1 16.1255 1.04813 16.3513 1.14165C16.577 1.23516 16.7822 1.37223 16.955 1.54503C17.1278 1.71782 17.2648 1.92296 17.3584 2.14872C17.4519 2.37449 17.5 2.61647 17.5 2.86083V4.66667"
        stroke="currentcolor"
        strokeWidth={sizeMap[size].strokeWidth}
      />
      <path d="M1 4.66669H23" stroke="currentcolor" strokeWidth={sizeMap[size].strokeWidth} />
    </svg>
  );
};
